// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TopBarVerticalDivider-base__M2uDY{flex-shrink:0;margin:var(--size-0) var(--size-2);color:var(--gray-a8);font:var(--font-body-400-compact);font-feature-settings:var(--feature-settings-body-400-compact);letter-spacing:var(--letter-spacing-body-400-compact)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "TopBarVerticalDivider-base__M2uDY"
};
export default ___CSS_LOADER_EXPORT___;
